import type { DefaultData } from '../ui/newStudyStep1/newStudyStep1.types';

// Fields intentionally start unset (blank new-study form); callers fill them in before use, but
// DefaultData models the post-fill shape, so an unknown-cast bridges the empty initial state.
const NEW_STUDY_STEP_1_DEFAULT_DATA = {
  patientId: undefined,
  firstName: undefined,
  middleName: undefined,
  lastName: undefined,
  dob: undefined,
  gender: 'Male',
  pacer: 'No',
  heightFt: undefined,
  heightIn: undefined,
  weight: undefined,
  icd: false,
  ethnicity: undefined,
} as unknown as DefaultData;

export { NEW_STUDY_STEP_1_DEFAULT_DATA };
